"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var IconButton_1 = require("@material-ui/core/IconButton");
var SnackbarContent_1 = require("@material-ui/core/SnackbarContent");
var CheckCircle_1 = require("@material-ui/icons/CheckCircle");
var Close_1 = require("@material-ui/icons/Close");
var Error_1 = require("@material-ui/icons/Error");
var Info_1 = require("@material-ui/icons/Info");
var Warning_1 = require("@material-ui/icons/Warning");
var withStyles_1 = require("@material-ui/styles/withStyles");
var styles_1 = require("./styles");
var variantIcon = {
    success: CheckCircle_1.default,
    warning: Warning_1.default,
    error: Error_1.default,
    info: Info_1.default,
};
function SnackbarContentWrapper(props) {
    var message = props.message, onClose = props.onClose, variant = props.variant, classes = props.classes;
    var Icon = variantIcon[variant];
    return (React.createElement(SnackbarContent_1.default, { className: classes[variant], "aria-describedby": "client-snackbar", message: (React.createElement("span", { id: "client-snackbar", className: classes.message },
            React.createElement(Icon, { className: classes.icon, style: { marginRight: 10 } }),
            message)), action: [
            (React.createElement(IconButton_1.default, { key: "close", "aria-label": "Close", color: "inherit", onClick: onClose },
                React.createElement(Close_1.default, { className: classes.icon }))),
        ] }));
}
exports.default = withStyles_1.default(styles_1.default)(SnackbarContentWrapper);
